import { useState, useMemo, useCallback } from "react";

const useSortableData = ({ 
    rows: items,
    tableDefaultSort: config,
    childRows,
    sortingMode
}) => {
    const [sortConfig, setSortConfig] = useState(config);

    const getSortFieldValue = field => {
        if (typeof field === 'string') {
            return field?.toLowerCase();
        }
        return field;
    };

    const sortItem = useCallback((a, b) => {
        if (getSortFieldValue(a[sortConfig.key]) < getSortFieldValue(b[sortConfig.key])) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (getSortFieldValue(a[sortConfig.key]) > getSortFieldValue(b[sortConfig.key])) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    }, [sortConfig]);
    
    const sortedItems = useMemo(() => {
        let sortableItems = Array.isArray(items) ? [...items] : [];
        
        if (sortConfig && sortingMode?.toLowerCase().trim() === 'client') {
            sortableItems.sort((a, b) => sortItem(a, b));

            if (childRows?.rows && childRows?.field) {
                sortableItems = [...sortableItems]?.map(item => {
                    const childRowArray = item?.[childRows.field] ?? [];
                    const sortedChildRowArray = [...childRowArray]?.sort((a, b) => sortItem(a, b));

                    return {
                        ...item,
                        [childRows.field]: sortedChildRowArray
                    };
                });
            }
        }
        return sortableItems;
    }, [items, sortConfig, childRows, sortItem, sortingMode]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === 'ascending'
        ) {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
        return { key, direction };
    };

    return { items: sortedItems, requestSort, sortConfig };
};

export default useSortableData;
